import React from 'react';
import { browserHistory } from 'react-router';
import './AlarmDetail.css';
import LContain from '../../layout/Contain/Contain';
import Alert from '../../components/Alert/Alert.js';
import Button from '../../components/Button/Button.js';
import DayPicker from '../../components/DayPicker/DayPicker.js';
import TimePicker from '../../components/TimePicker/TimePicker.js';

import {
  inject,
  observer
} from 'mobx-react';

import { getNextSoundDate } from '../../utils/alarms';
import { getTimeUntil } from '../../utils/datetime';
import { setBackground } from '../../utils/style';

class AlarmDetail extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      hours: 12,
      minutes: 0,
      days: []
    };

    this.getAlarmSaveData = this.getAlarmSaveData.bind(this);
    this.getTimeUntilNextAlarm = this.getTimeUntilNextAlarm.bind(this);
    this.toggleDay = this.toggleDay.bind(this);
    this.increaseHour = this.increaseHour.bind(this);
    this.decreaseHour = this.decreaseHour.bind(this);
    this.increaseMinute = this.increaseMinute.bind(this);
    this.decreaseMinute = this.decreaseMinute.bind(this);
    this.togglePeriod = this.togglePeriod.bind(this);
    this.togglePeriod = this.togglePeriod.bind(this);
    this.cancel = this.cancel.bind(this);
    this.delete = this.delete.bind(this);
    this.save = this.save.bind(this);
  }

  render() {
    return (
      <LContain>
        <div className='alarm-edit mt-4 u-grow u-dir-column'>
            <div className='alarm-edit__top mb-4 u-grow'>
              <div className='alarm-edit__days'>
                <DayPicker
                  activeDays={this.state.days}
                  onDayClick={this.toggleDay}
                />
              </div>
              <div className='alarm-edit__time'>
                <TimePicker
                  hours={this.state.hours}
                  minutes={this.state.minutes}
                  onIncreaseHourClick={this.increaseHour}
                  onDecreaseHourClick={this.decreaseHour}
                  onIncreaseMinuteClick={this.increaseMinute}
                  onDecreaseMinuteClick={this.decreaseMinute}
                  onIncreasePeriodClick={this.togglePeriod}
                  onDecreasePeriodClick={this.togglePeriod}
                />
              </div>
            </div>
            <div className='alarm-edit__bottom mb-4'>
              {this.state.days.length ?
                <Alert>Sounds in: {this.getTimeUntilNextAlarm()}</Alert>
              : null}
              <div className='alarm-edit__actions'>
                <Button
                  size='md'
                  type='blue'
                  onClick={this.cancel}>
                  Cancel
                </Button>
                <Button
                  size='md'
                  type='red'
                  onClick={this.delete}>
                  Delete
                </Button>
                <Button
                  size='md'
                  type='green'
                  onClick={this.save}>
                  Save
                </Button>
              </div>
            </div>
        </div>
      </LContain>
    );
  }

  componentWillMount() {
    let self = this;
    let alarmStore = this.props.alarmStore;

    setBackground('blue');

    if (self.props.params.id) {

      alarmStore.get(parseInt(this.props.params.id, 10), function(alarm) {
        if (alarm) {
          self.setState({
            alarm: alarm,
            hours: alarm.hours,
            minutes: alarm.minutes,
            days: alarm.days
          });
        }
      });
    }
  }

  getAlarmSaveData() {
    return {
      hours: this.state.hours,
      minutes: this.state.minutes,
      days: this.state.days.sort()
    }
  }

  getTimeUntilNextAlarm() {
    const nextSound = getNextSoundDate({
      days: this.state.days,
      hours: this.state.hours,
      minutes: this.state.minutes,
    });

    return getTimeUntil(nextSound);
  }

  // getTimeUntilNextAlarm() {
  //   const now = new Date();
  //   const todayDayNumber = now.getDay() + 1;
  //   const nextAlarmDaysInWeek = this.state.days.filter(day => day > todayDayNumber).sort();

  //   // Alarm occurs in the future today
  //   if (
  //     (now.getHours() < this.state.hours || (
  //       now.getHours() === this.state.hours && now.getMinutes() < this.state.minutes)
  //     ) && this.state.days.includes(todayDayNumber)
  //   ) {

  //     const timeUntil = (this.state.hours + (this.state.minutes / 60)) - (now.getHours() + (now.getMinutes() / 60));
  //     const hoursUntil = Math.floor(timeUntil);
  //     const minutesUntil = Math.floor((timeUntil - hoursUntil) * 60);

  //     return `${hoursUntil ? hoursUntil + ' hours,' : ''} ${minutesUntil} minutes`;

  //   } else if (this.state.days.includes(todayDayNumber + 1)) {

  //     // Alarm occurs tomorrow, within 24 hours of now
  //     if (now.getHours() > this.state.hours || (now.getHours() === this.state.hours && now.getMinutes() > this.state.minutes)) {

  //       const timeUntil = 24 - (now.getHours() + (now.getMinutes() / 60)) + (this.state.hours + (this.state.minutes / 60));
  //       const hoursUntil = Math.floor(timeUntil);
  //       const minutesUntil = Math.round((timeUntil - hoursUntil) * 60);

  //       return `${hoursUntil ? hoursUntil + ' hours,' : ''} ${minutesUntil} minutes`;

  //     } else {
  //       return '1 Day';
  //     }

  //   } else if (nextAlarmDaysInWeek.length) {

  //     return `${nextAlarmDaysInWeek[0] - todayDayNumber} days`;

  //   } else {

  //     return `${7 - todayDayNumber + this.state.days[0]} days`;

  //   }

  // }

  toggleDay(dayIndex) {
    let newRepeatDays;

    if (this.state.days.includes(dayIndex)) {
      newRepeatDays = this.state.days.filter(day => day !== dayIndex);
    } else {
      newRepeatDays = this.state.days.concat(dayIndex);
    }

    this.setState({
      days: newRepeatDays
    });
  }

  increaseHour() {
    let hours = this.state.hours + 1;

    if (this.state.hours === 11) {
      hours = 0;
    } else if (this.state.hours === 23) {
      hours = 12;
    }

    this.setState({
      hours: hours
    });
  }

  decreaseHour() {
    let hours = this.state.hours - 1;

    if (this.state.hours === 0) {
      hours = 11;
    } else if (this.state.hours === 12) {
      hours = 23;
    }

    this.setState({
      hours: hours
    });
  }

  increaseMinute() {
    let minutes = 0;

    if (this.state.minutes < 59) {
      minutes = this.state.minutes + 1;
    }

    this.setState({
      minutes: minutes
    });
  }

  decreaseMinute() {
    let minutes = 59;

    if (this.state.minutes !== 0) {
      minutes = this.state.minutes - 1;
    }

    this.setState({
      minutes: minutes
    });
  }

  togglePeriod() {
    let hours;

    if (this.state.hours >= 12) {
      hours = this.state.hours - 12;
    } else {
      hours = this.state.hours + 12;
    }

    this.setState({
      hours: hours
    });
  }

  cancel() {
    browserHistory.push('/alarms/');
  }

  delete() {
    this.state.alarm.delete();
    browserHistory.push('/alarms/');
  }

  save() {
    let alarmData = this.getAlarmSaveData();

    if (this.state.alarm) {
      this.state.alarm.update(alarmData);
    } else {
      alarmData.is_active = true;
      this.props.alarmStore.add(alarmData);
    }

    browserHistory.push('/alarms/');
  }

};

export default inject('alarmStore')(observer(AlarmDetail));



// WEBPACK FOOTER //
// ./src/views/AlarmDetail/index.js